export default __webpack_public_path__ + "static/char-v-55-a016de5ce4ea39469eb7813ec04a15f1.png";